// extracted by mini-css-extract-plugin
export default {"storyWrapper":"LandscapeStoryOrganism_storyWrapper__SRGwi"};